import { render } from "./TranscriptionBotAlert.vue?vue&type=template&id=479593eb&scoped=true"
import script from "./TranscriptionBotAlert.vue?vue&type=script&lang=js"
export * from "./TranscriptionBotAlert.vue?vue&type=script&lang=js"

import "./TranscriptionBotAlert.vue?vue&type=style&index=0&id=479593eb&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-479593eb"

export default script